import { Popover as Root } from './Popover';
import { PopoverContent as Content } from './PopoverContent';
import { PopoverTrigger as Trigger } from './PopoverTrigger';
const Popover = { Root, Trigger, Content };
export { Popover };
//# sourceMappingURL=index.js.map